import { render, staticRenderFns } from "./MessageChipsListItem.vue?vue&type=template&id=659e61e4&scoped=true"
import script from "./MessageChipsListItem.vue?vue&type=script&lang=js"
export * from "./MessageChipsListItem.vue?vue&type=script&lang=js"
import style0 from "./MessageChipsListItem.vue?vue&type=style&index=0&id=659e61e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659e61e4",
  null
  
)

export default component.exports